import styles from './styles.module.scss';
import { getNoteTypes } from '../../utils/notes.jsx';

const NoteButton = ({ t, type, color, count = 0, isButton = true, onButtonClick }) => {
  const NoteTypes = getNoteTypes(t);

  const handleClick = (e) => {
    e.preventDefault();
    // e.stopPropagation();
    // if (e.cancelable) e.preventDefault();
    onButtonClick();
  };

  return (
    <>
      {isButton ? (
        <button
          className={styles.noteTypeButton}
          style={{ color: color ? color : 'transparent' }}
          onClick={(event) => handleClick(event)}
        >
          {NoteTypes[type].icon}
          {count > 1 ? <span className={styles.noteTypeButtonCount}>{count}</span> : ''}
        </button>
      ) : (
        <div className={styles.noteTypeButton} style={{ color: color ? color : 'transparent' }}>
          {NoteTypes[type].icon}
        </div>
      )}
    </>
  );
};

export default NoteButton;
